export default __webpack_public_path__ + "87c7c6b3343bccfa4d1619b5b5021e66.otf";